module.exports = __webpack_public_path__ + "img/asus_pic1.c7968683.png";